<template><section>

<h2 id="switch-zu-jian"><a class="header-anchor" href="#switch-zu-jian" aria-hidden="true">¶</a> Switch组件</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa" aria-hidden="true">¶</a> 基础用法</h3>
<demo-block class="demo-box">
                            <div class="source" slot="source"><div class="page-switch">
  <span class="page-switch-text">Switch state: {{switchStateText}}</span>
  <o2-switch class="page-switch-sample" :checked="switchState" :onchange="updateState"></o2-switch>
  <o2-switch class="page-switch-sample" :checked="false" :disabled="true"></o2-switch>
</div>
</div>
                            <p>样例代码</p>

                            <div class="highlight" slot="highlight"><pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"page-switch"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"page-switch-text"</span>&gt;</span>Switch state: <span>{{</span>switchStateText<span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">o2-switch</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"page-switch-sample"</span> <span class="hljs-attr">:checked</span>=<span class="hljs-string">"switchState"</span> <span class="hljs-attr">:onChange</span>=<span class="hljs-string">"updateState"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">o2-switch</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">o2-switch</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"page-switch-sample"</span> <span class="hljs-attr">:checked</span>=<span class="hljs-string">"false"</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">o2-switch</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
</code></pre>
<pre><code class="hljs language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">switchState</span>: <span class="hljs-literal">false</span>
    };
  },
  <span class="hljs-attr">computed</span>: {
    switchStateText() {
      <span class="hljs-keyword">return</span> <span class="hljs-keyword">this</span>.switchState ? <span class="hljs-string">'on'</span> : <span class="hljs-string">'off'</span>;
    }
  },
  <span class="hljs-attr">methods</span>: {
    updateState(newState) {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'changing'</span>);
      <span class="hljs-keyword">this</span>.switchState = newState;
    }
  }
};
</code></pre>
</div></demo-block>
<h3 id="api"><a class="header-anchor" href="#api" aria-hidden="true">¶</a> API</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>checked</td>
<td>开关状态</td>
<td>boolean</td>
<td>false</td>
<td>true,false</td>
</tr>
<tr>
<td>loading</td>
<td>loading状态</td>
<td>boolean</td>
<td>false</td>
<td>true,false</td>
</tr>
<tr>
<td>disabled</td>
<td>禁用状态</td>
<td>boolean</td>
<td>false</td>
<td>true,false</td>
</tr>
<tr>
<td>onChange</td>
<td>回调</td>
<td>function</td>
<td>function（）{}</td>
<td>-</td>
</tr>
</tbody>
</table>
</section></template>
<style lang="css">
  @component-namespace page {
    @component switch {
      padding: 0 15px 15px;

      @descendent sample {
        margin: 0 15px;
      }

      @descendent text {
        margin-right: 20px;
      }
    }
  }
</style>
<script>
export default {
  data() {
    return {
      switchState: true
    };
  },
  computed: {
    switchStateText() {
      return this.switchState ? 'ON' : 'OFF';
    }
  },
  methods: {
    updateState(newState) {
      console.log('changing');
      this.switchState = newState;
    }
  }
};
</script>


// WEBPACK FOOTER //
// switch-3.vue?34d79a48